<div class="w-full px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:pt-4 bg-white" *ngIf="isStandalone">
  <app-breadcrum [data]="scrapCertificateBreadcrumbs"></app-breadcrum>
</div>
<div [class.px-4]="isStandalone" [class.sm:px-6]="isStandalone" [class.lg:px-8]="isStandalone">
<!-- header -->
<div class="w-full max-w-full mx-auto flex flex-col p-4 sm:p-6 lg:p-12 gap-4 sm:gap-6 max-md:p-0 max-md:gap-3">
    <div class="flex flex-row justify-between items-center gap-2 sm:gap-4 mb-3 mt-0 sm:mt-0 w-full">
        <h2 class="text-black text-xl sm:text-2xl lg:text-[24px] font-bold leading-6 sm:leading-8 lg:leading-[32px] flex-1 min-w-0 pr-2">Scrap Certificate</h2>
        <button  *ngIf="certificates?.length !== 0"
          class="flex h-10 p-2 justify-center items-center gap-1 rounded-lg border border-[#0A0A5F] w-[119px] sm:w-auto shrink-0"
          (click)="openModal(null, 'add')"
        >
          <span class="text-sm sm:text-base lg:text-lg font-medium">+ Add Certificate</span>    
        </button>
    </div>

    <!-- container -->
    <div class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-3 sm:gap-4">
        
        <div *ngFor="let cert of certificates; let i = index" class="border border-[#E5E5E5] rounded-lg p-3 sm:p-4 flex flex-col h-full">

            <div class="flex-1">
                <div class="flex sm:flex-row justify-between sm:items-center gap-2 sm:gap-0 mb-3">

                    <h3 class="text-base sm:text-lg font-semibold whitespace-nowrap">{{ cert.category }}</h3>

                    <span class="text-xs font-semibold rounded-full px-2 py-0.5 flex items-center w-fit sm:ml-0" [ngClass]="{
                                       'bg-green-100 text-green-800': cert.status === 'Valid',
                                       'bg-yellow-100 text-yellow-800': cert.status === 'Expiring Soon',
                                       'bg-red-100 text-red-800': cert.status === 'Expired' || cert.status === 'Rejected',
                                       'bg-blue-100 text-blue-800': cert.status === 'Pending'
                                      }">
                        <span class="w-3 h-3 sm:w-4 sm:h-4 sm:mt-[4px]" [innerHTML]="statusIcons[getStatusKey(cert.status)]"></span>
                        <span class="hidden sm:inline">{{ cert.status }}</span>
                        <span class="sm:hidden">{{ cert.status.length > 8 ? cert.status.substring(0, 8) + '...' : cert.status }}</span>
                    </span>

                </div>


                <div class="space-y-2">
                    <div class="text-xs sm:text-sm text-[#E30613] flex items-center gap-[5px]"
                        *ngIf="cert.status === 'Rejected'">
                        <span> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none" class="sm:w-4 sm:h-4">
                                <g clip-path="url(#clip0_2215_41832)">
                                    <path
                                        d="M7.99951 0.666504C12.0494 0.66668 15.3325 3.95051 15.3325 8.00049C15.3323 12.0502 12.0493 15.3333 7.99951 15.3335C3.94974 15.3333 0.665791 12.0502 0.665527 8.00049C0.665527 3.95051 3.94957 0.66668 7.99951 0.666504ZM7.99951 2.00049C4.68595 2.00066 1.99951 4.68689 1.99951 8.00049C1.99978 11.3139 4.68612 14.0003 7.99951 14.0005C11.3129 14.0003 13.9992 11.3139 13.9995 8.00049C13.9995 4.68689 11.3131 2.00066 7.99951 2.00049ZM7.99951 6.6665C8.36755 6.66668 8.66553 6.96541 8.66553 7.3335V11.3335C8.66544 11.7015 8.3675 12.0003 7.99951 12.0005C7.63153 12.0003 7.33261 11.7015 7.33252 11.3335V7.3335C7.33252 6.96542 7.63147 6.66668 7.99951 6.6665ZM7.99951 4.00049C8.36765 4.00049 8.66642 4.29839 8.6665 4.6665C8.6665 5.03469 8.3677 5.3335 7.99951 5.3335C7.63132 5.3335 7.33252 5.03469 7.33252 4.6665C7.33261 4.29839 7.63138 4.00049 7.99951 4.00049Z"
                                        fill="#E30613" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2215_41832">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                        <span class="whitespace-nowrap">Image of the attachment is not clear</span>
                        <!-- <span class="sm:hidden">Image not clear</span> -->
                    </div>
                    <div class="text-xs sm:text-sm text-blue-800 flex items-center gap-[5px]"
                        *ngIf="cert.status === 'Pending'"> 
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none" class="sm:w-4 sm:h-4">
                                <g clip-path="url(#clip0_2215_41819)">
                                    <path
                                        d="M7.99951 0.666504C12.0494 0.66668 15.3325 3.95051 15.3325 8.00049C15.3323 12.0502 12.0493 15.3333 7.99951 15.3335C3.94974 15.3333 0.665791 12.0502 0.665527 8.00049C0.665527 3.95051 3.94957 0.66668 7.99951 0.666504ZM7.99951 2.00049C4.68595 2.00066 1.99951 4.68689 1.99951 8.00049C1.99978 11.3139 4.68612 14.0003 7.99951 14.0005C11.3129 14.0003 13.9992 11.3139 13.9995 8.00049C13.9995 4.68689 11.3131 2.00066 7.99951 2.00049ZM7.99951 6.6665C8.36755 6.66668 8.66553 6.96541 8.66553 7.3335V11.3335C8.66544 11.7015 8.3675 12.0003 7.99951 12.0005C7.63153 12.0003 7.33261 11.7015 7.33252 11.3335V7.3335C7.33252 6.96542 7.63147 6.66668 7.99951 6.6665ZM7.99951 4.00049C8.36765 4.00049 8.66642 4.29839 8.6665 4.6665C8.6665 5.03469 8.3677 5.3335 7.99951 5.3335C7.63132 5.3335 7.33252 5.03469 7.33252 4.6665C7.33261 4.29839 7.63138 4.00049 7.99951 4.00049Z"
                                        fill="#0A0A5F" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2215_41819">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                        <span class="whitespace-nowrap">Verification may take 2–3 business days.</span>
                        <!-- <span class="sm:hidden">Verification in 2-3 days</span> -->
                    </div>
                    <p class="text-xs sm:text-sm text-[#777]">Certificate: {{ cert.certificate_name }}</p>

                    <div class="text-[#777] text-xs sm:text-sm leading-4 sm:leading-5 font-bold">

                        <p class="text-[#777]">{{ cert.date }}</p>
                    </div>
                </div>
            </div>


 



                <!-- <p class="text-sm text-gray-600" *ngIf="cert.status === 'Pending'">Uploaded on {{ cert.date }}</p> -->





            <div class="mt-auto pt-3">
                <!-- Button logic based on certificate status -->
                <button *ngIf="cert?.status === 'Rejected'" 
                    class="py-2 sm:py-2.5 px-3 rounded-lg bg-[#0A0A5F] text-white font-medium text-xs sm:text-sm w-full"
                    (click)="openModal(cert, 'upload')">
                    Upload Again
                </button>
                
                <button *ngIf="cert?.status !== 'Rejected'" 
                    class="py-2 sm:py-2.5 px-3 rounded-lg border-2 border-[#0A0A5F] text-[#0A0A5F] font-bold text-xs sm:text-sm w-full"
                    (click)="openModal(cert)">
                    {{ cert?.status === 'Expired' ? 'View Certificates' : 'View Details' }}
                </button>
            </div>
        </div>
    </div>

    <div class="text-center justify-center text-sm text-black" *ngIf="certificates?.length === 0">
      <h4 class="text-lg font-bold">No certificates found</h4>

      <button 
      class=" h-10 p-2 justify-center mt-3 gap-1 rounded-lg border border-[#0A0A5F] w-[119px] sm:w-auto"
      (click)="openModal(null, 'add')"
    >
      <span class="text-sm sm:text-base lg:text-lg font-medium">+ Add Certificate</span>    
    </button>
     </div>



<!-- --------page popup -->


<!-- Modal -->
<div *ngIf="modalType === 'upload' || modalType === 'details'" class="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black bg-opacity-40 p-0 sm:p-4">
    <div class="w-full h-full sm:w-full sm:max-w-2xl sm:h-auto sm:rounded-2xl bg-white shadow-[2px_2px_12px_rgba(0,0,0,0.10)] p-4 sm:p-6 relative flex flex-col overflow-hidden">
        <!-- Scrollable Content Area -->
        <div class="flex-1 overflow-y-auto">
        <!-- Mobile Header -->
        <div class="flex justify-between items-center mb-4 sm:mb-6 max-md:border-b">
            <h2 class="text-2xl sm:text-xl font-bold text-[#0A0A5F]">Certificate Details</h2>
            <button (click)="closeModal()" class="text-gray-600 text-xl sm:text-xl">×</button>
        </div>
        
        <!-- Mobile Certificate Status Section -->
        <div *ngIf="selectedCertificate" class="mb-6 sm:mb-4">
            <div class="flex justify-between items-center">
                <div class="text-sm sm:text-sm font-bold">Certificate</div>
                <div class="text-xs font-semibold rounded-full px-3 py-1 flex items-center gap-1 bg-green-100 text-green-800" [ngClass]="{
                    'bg-green-100 text-green-800': selectedCertificate?.status === 'Valid',
                    'bg-yellow-100 text-yellow-800': selectedCertificate?.status === 'Expiring Soon',
                    'bg-red-100 text-red-800': selectedCertificate?.status === 'Expired' || selectedCertificate?.status === 'Rejected',
                    'bg-blue-100 text-blue-800': selectedCertificate?.status === 'Pending'
                }">
                    <span class="w-4 h-4" [innerHTML]="statusIcons[getStatusKey(selectedCertificate?.status)]"></span>
                    <span class="sm:hidden">{{ selectedCertificate?.status }}</span>
                    <span class="hidden sm:inline">{{ selectedCertificate?.status }}</span>
                </div>
            </div>
        </div>



        <!-- Certificate Info -->
        <!-- Conditional Certificate Info / Pending / Rejected Message -->
        <ng-container [ngSwitch]="selectedCertificate?.status">

            <!-- Show certificate info if not Pending or Rejected -->
            <div *ngSwitchDefault class="grid grid-cols-2 gap-3 sm:gap-3 sm:gap-4 lg:grid-cols-3 text-sm">
                <div class="space-y-1">
                    <p class="text-gray-500 text-sm">Certificate Name</p>
                    <p class="font-bold text-black">{{selectedCertificate?.certificate_name}}</p>
                </div>
                <div class="space-y-1">
                    <p class="text-gray-500 text-sm">Certificate No.</p>
                    <p class="font-bold text-black">{{selectedCertificate?.certificate_no}}</p>
                </div>
                <div class="space-y-1">
                    <p class="text-gray-500 text-sm">Issuing Authority</p>
                    <p class="font-bold text-black">{{selectedCertificate?.issuing_authority}}</p>
                </div>
                <div class="space-y-1">
                    <p class="text-gray-500 text-sm">Company Name</p>
                    <p class="font-bold text-black">{{selectedCertificate?.company_name}}</p>
                </div>
                <div class="space-y-1">
                    <p class="text-gray-500 text-sm">Issue Date</p>
                    <p class="font-bold text-black">{{selectedCertificate?.issue_date}}</p>
                </div>
                <div class="space-y-1">
                    <p class="text-gray-500 text-sm">Expiry Date</p>
                    <p class="font-bold text-black">{{selectedCertificate?.expiry_date}}</p>
                </div>
                <div class="space-y-1 col-span-2 sm:col-span-1 lg:col-span-1">
                    <p class="text-gray-500 text-sm">Category</p>
                    <p class="font-bold text-black">{{selectedCertificate?.category}}</p>
                </div>
            </div>

            <!-- Show Pending Message -->
            <ng-template ngSwitchCase="Pending">
              <div class="space-y-1 col-span-2 sm:col-span-1 lg:col-span-1">
                <p class="text-gray-500 text-sm">Category</p>
                <p class="font-bold text-black">{{selectedCertificate?.category}}</p>
            </div>
                <div class="mt-4 text-xs sm:text-sm text-[#0A0A5F] bg-[#F2F2F2] border border-blue-200 p-3 sm:p-4 leading-5 sm:leading-6">
                    <p class="text-[#0A0A5F] text-sm sm:text-base leading-5 sm:leading-6 font-bold">Pending Approval</p>

                   
                    <ul class="list-disc pl-4 sm:pl-5 space-y-1 text-black">
                        <li>The certificate will be verified by the Rewire team.</li>
                        <li>They may contact you if any additional information is required.</li>
                        <li>The verification process may take 2–3 business days.</li>
                    </ul>
                </div>
            </ng-template>

            <!-- Show Rejected Message -->
            <ng-template ngSwitchCase="Rejected">

              <div class="space-y-1 col-span-2 sm:col-span-1 lg:col-span-1">
                <p class="text-gray-500 text-sm">Category</p>
                <p class="font-bold text-black">{{selectedCertificate?.category}}</p>
            </div>
                <div class="mt-4 text-xs sm:text-sm text-[#0A0A5F] bg-[#F2F2F2] border border-blue-200 p-3 sm:p-4 leading-5 sm:leading-6">
                    <p class="text-[#0A0A5F] text-sm sm:text-base leading-5 sm:leading-6 font-bold">Reason for rejection</p>
                    <ul class="list-disc pl-4 sm:pl-5 space-y-1 text-black">
                        <li>{{ selectedCertificate?.rejectionReason || 'Image of the attachment is not clear' }}</li>
                    </ul>
                </div>
            </ng-template>

        </ng-container>






        <!-- Attachments -->
        <div class="mt-8 sm:mt-6">
            <!-- header -->
            <div class="flex justify-between items-center mb-4">
                <h3 class="font-bold text-lg sm:text-base">Attachments</h3>
                <a class="text-[#307FE1] text-center font-bold text-sm leading-5 cursor-pointer" (click)="downloadAllAttachments(selectedCertificate)">Download All</a>
            </div>

            <!-- imageList -->
            <div class="flex items-start gap-2 sm:gap-4 overflow-auto">
                <div *ngFor="let attachment of selectedCertificate?.image_path" class="flex justify-center items-center w-16 h-16 sm:w-20 sm:h-20 aspect-square rounded-lg bg-[#C0D8F6] border-2 border-solid border-black cursor-pointer" (click)="viewAttachment(attachment)">
                    <!-- Display image if it's an image file -->
                    <img *ngIf="!isAttachmentPDF(attachment)" [src]="attachment" alt="cert" class="w-full h-full object-cover rounded-lg" />
                    
                    <!-- Display PDF icon if it's a PDF file -->
                    <div *ngIf="isAttachmentPDF(attachment)" class="w-full h-full flex flex-col items-center justify-center text-gray-600">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-red-600">
                            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                        </svg>
                        <span class="text-xs mt-1 text-center text-red-600 font-semibold">PDF</span>
                    </div>
                </div>
            </div>
        </div>






        </div>
        <!-- Footer Buttons -->
        <div *ngIf="modalType === 'upload'" class="flex-shrink-0 mt-4 sm:mt-6 pt-4 sm:pt-0 border-t sm:border-t-0 flex flex-row justify-between gap-3 w-full">
            <button class="flex-1 border border-[#0A0A5F] text-[#0A0A5F] font-medium px-3 sm:px-4 py-2 rounded text-sm sm:text-base" (click)="closeModal()" >Cancel</button>
            <button class="flex-1 bg-[#0A0A5F] text-white font-medium px-3 sm:px-4 py-2 rounded text-sm sm:text-base"  (click)="openModal(selectedCertificate, 'add')">Upload New Certificate</button>
        </div>


    </div>




</div>

<!-- Add Certificate Modal -->
<div *ngIf="modalType === 'add'" class="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black bg-opacity-50 p-0 sm:p-4">
  <div class="w-full h-full max-h-screen sm:w-full sm:max-w-2xl sm:h-auto sm:max-h-[90vh] sm:rounded-2xl bg-white shadow-[2px_2px_12px_rgba(0,0,0,0.10)] relative flex flex-col animate-slide-up">
    <!-- Header - Fixed -->
    <div class="flex-shrink-0 flex justify-between items-center p-4 sm:p-6 border-b border-gray-200">
      <h2 class="text-lg sm:text-xl lg:text-[24px] leading-6 sm:leading-8 lg:leading-[32px] font-bold font-['Uni Neue'] text-[color:var(--Primary-Deep-Blue,#0A0A5F)]">Upload Scrap Certificates</h2>
      <button (click)="closeModal()" class="text-gray-500 hover:text-gray-700 text-xl p-1">✕</button>
    </div>
    
    <!-- Scrollable Content -->
    <div class="flex-1 overflow-y-auto p-4 sm:p-6 space-y-4 sm:space-y-6">
      <form [formGroup]="certificateForm" (ngSubmit)="onSubmit()">
        <!-- Scrap Category -->
        <div class="space-y-2">
          <label class="block text-xs sm:text-sm font-semibold text-[#000]">Scrap Category <span class="text-red-500">*</span></label>
          <div class="relative">
            <!-- Desktop: Native select -->
            <select formControlName="scrapCategory" 
              class="hidden sm:block w-full border border-gray-300 rounded-lg px-3 py-2.5 sm:py-2 text-xs sm:text-sm text-gray-700 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
              [class.border-red-500]="isFieldInvalid('scrapCategory')">
              <option value="">Select any one Category</option>
              <option *ngFor="let category of scrapCategoryOptions" [value]="category?.name">{{ category?.name }}</option>
            </select>
            <!-- Mobile: Custom button that opens bottom sheet -->
            <button type="button"
              (click)="openCategoryBottomSheet()"
              class="sm:hidden w-full border border-gray-300 rounded-lg px-3 py-2.5 text-xs text-gray-700 bg-white text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent flex items-center justify-between"
              [class.border-red-500]="isFieldInvalid('scrapCategory')">
              <span [class.text-gray-400]="!certificateForm.get('scrapCategory')?.value">{{ getSelectedCategoryDisplay() }}</span>
              <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
          </div>
          <div *ngIf="isFieldInvalid('scrapCategory')" class="text-red-500 text-xs mt-1">
            {{ getFieldError('scrapCategory') }}
          </div>
        </div>

        <!-- Certificate Name and Number -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div class="space-y-2">
            <label class="block text-xs sm:text-sm font-bold text-zinc-700">Certificate Name <span class="text-red-500">*</span></label>
            <input type="text"
              (keydown)="preventLeadingSpace($event, $event.target)"
              (input)="handleInput($event, 'certificateName')"
              (paste)="handlePaste($event, 'certificateName')"
              (blur)="handleBlur($event, 'certificateName')"
              formControlName="certificateName"
              placeholder="Enter Certificate name"
              class="w-full p-2 sm:p-3 text-sm sm:text-base font-medium text-black rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              [class.border-red-500]="isFieldInvalid('certificateName')" />
            <div *ngIf="isFieldInvalid('certificateName')" class="text-red-500 text-xs mt-1">
              {{ getFieldError('certificateName') }}
            </div>
          </div>
          <div class="space-y-2">
            <label class="block text-xs sm:text-sm font-bold text-zinc-700">Certificate No. <span class="text-red-500">*</span></label>
            <input type="text"
              formControlName="certificateNumber"
              (keydown)="preventLeading($event, $event.target)"
              (input)="handleInput($event, 'certificateNumber')"
              (paste)="handlePaste($event, 'certificateNumber')"
              (blur)="handleBlur($event, 'certificateNumber')"
              placeholder="Enter Certificate No."
              class="w-full p-2 sm:p-3 text-sm sm:text-base font-medium text-black rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              [class.border-red-500]="isFieldInvalid('certificateNumber')" />
            <div *ngIf="isFieldInvalid('certificateNumber')" class="text-red-500 text-xs mt-1">
              {{ getFieldError('certificateNumber') }}
            </div>
          </div>
        </div>

        <!-- Issuing Authority and Company Name -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div class="space-y-2">
            <label class="block text-xs sm:text-sm font-bold text-zinc-700">Issuing Authority <span class="text-red-500">*</span></label>
            <input type="text"
              formControlName="issuingAuthority"
              placeholder="Enter issuing authority name"
              (keydown)="preventLeadingSpace($event, $event.target)"
              (input)="handleInput($event, 'issuingAuthority')"
              (paste)="handlePaste($event, 'issuingAuthority')"
              (blur)="handleBlur($event, 'issuingAuthority')"
              class="w-full p-2 sm:p-3 text-sm sm:text-base font-medium text-black rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              [class.border-red-500]="isFieldInvalid('issuingAuthority')" />
            <div *ngIf="isFieldInvalid('issuingAuthority')" class="text-red-500 text-xs mt-1">
              {{ getFieldError('issuingAuthority') }}
            </div>
          </div>
          <div class="space-y-2">
            <label class="block text-xs sm:text-sm font-bold text-zinc-700">Company Name <span class="text-red-500">*</span></label>
            <input type="text"
              formControlName="companyName"
              placeholder="Enter company name"
              (keydown)="preventLeadingSpace($event, $event.target)"
              (input)="handleInput($event, 'companyName')"
              (paste)="handlePaste($event, 'companyName')"
              (blur)="handleBlur($event, 'companyName')"
              class="w-full p-2 sm:p-3 text-sm sm:text-base font-medium text-black rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              [class.border-red-500]="isFieldInvalid('companyName')" />
            <div *ngIf="isFieldInvalid('companyName')" class="text-red-500 text-xs mt-1">
              {{ getFieldError('companyName') }}
            </div>
          </div>
        </div>

        <!-- Issue Date and Expiry Date -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div class="space-y-2">
            <label class="block text-xs sm:text-sm font-bold text-zinc-700">Issue Date <span class="text-red-500">*</span></label>
            <div class="relative">
              <!-- Desktop: Native date input -->
              <input type="date" formControlName="issueDate" placeholder="Issue date of certificate" 
                min="1000-01-01" max="9999-12-31"
                class="hidden sm:block w-full sm:p-3 sm:text-base font-medium text-black rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                [class.border-red-500]="isFieldInvalid('issueDate')" />
              <!-- Mobile: Custom button that opens bottom sheet -->
              <button type="button"
                (click)="openDatePicker('issueDate', $event)"
                class="sm:hidden w-full p-2 text-sm font-medium rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] bg-white text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent flex items-center justify-between"
                [class.border-red-500]="isFieldInvalid('issueDate')">
                <span [class.text-gray-400]="!certificateForm.get('issueDate')?.value"
                      [class.text-black]="certificateForm.get('issueDate')?.value">
                  {{ getSelectedDateDisplay('issueDate') }}
                </span>
                <svg class="w-5 h-5 text-gray-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </button>
            </div>
            <div *ngIf="isFieldInvalid('issueDate')" class="text-red-500 text-xs mt-1">
              {{ getFieldError('issueDate') }}
            </div>
          </div>
          <div class="space-y-2">
            <label class="block text-xs sm:text-sm font-bold text-zinc-700">Expiry Date <span class="text-red-500">*</span></label>
            <div class="relative">
              <!-- Desktop: Native date input -->
              <input type="date" formControlName="expiryDate" placeholder="Expiry date of certificate"
                min="1000-01-01" max="9999-12-31"
                class="hidden sm:block w-full sm:p-3 sm:text-base font-medium text-black rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                [class.border-red-500]="isFieldInvalid('expiryDate')" />
              <!-- Mobile: Custom button that opens bottom sheet -->
              <button type="button"
                (click)="openDatePicker('expiryDate', $event)"
                class="sm:hidden w-full p-2 text-sm font-medium rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] bg-white text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent flex items-center justify-between"
                [class.border-red-500]="isFieldInvalid('expiryDate')">
                <span [class.text-gray-400]="!certificateForm.get('expiryDate')?.value"
                      [class.text-black]="certificateForm.get('expiryDate')?.value">
                  {{ getSelectedDateDisplay('expiryDate') }}
                </span>
                <svg class="w-5 h-5 text-gray-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </button>
            </div>
            <div *ngIf="isFieldInvalid('expiryDate')" class="text-red-500 text-xs mt-1">
              {{ getFieldError('expiryDate') }}
            </div>
          </div>
        </div>

        <!-- Upload Box -->
        <div class="space-y-4">
          <label class="block text-xs sm:text-sm font-semibold text-[#000]">Certificate Files <span class="text-red-500">*</span></label>
          
          <!-- Main Upload Area - Show when no images are selected -->
          <div *ngIf="ImageAray.length === 0" class="flex flex-col items-center justify-center border-2 border-dashed border-[color:var(--Primary-Deep-Blue,#0A0A5F)] rounded-lg py-6 sm:py-6 cursor-pointer text-[#307FE1] hover:bg-blue-50 transition-colors" (click)="fileInput.click()">
            <input type="file" accept=".jpg,.jpeg,.png,.webp,.pdf" #fileInput class="hidden" (change)="onFileUpload($event)" />
            
            <!-- Clickable SVG -->
            <div class="cursor-pointer inline-block">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 56 56" fill="none" class="sm:w-14 sm:h-14">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M14.0848 19.0012C15.3425 19.0012 16.5596 19.1665 17.7191 19.4756C19.4297 13.2683 25.1149 8.70898 31.8631 8.70898C38.6261 8.70898 44.3188 13.2848 46.017 19.5111C49.3135 19.8944 51.8746 22.695 51.8746 26.0944C51.8746 26.9257 51.7212 27.7186 51.4433 28.4518C54.1865 30.306 56 33.4445 56 36.9878C56 42.6513 51.3667 47.2845 45.7032 47.2845H33.0464C32.7077 47.2845 32.4331 47.01 32.4331 46.6712V35.8544C32.4331 35.5157 32.7077 35.2411 33.0464 35.2411H35.2103C35.7461 35.2411 36.0243 34.6023 35.6594 34.21L28.4499 26.4598C28.2074 26.1991 27.7944 26.1991 27.5518 26.4598L20.3424 34.21C19.9775 34.6023 20.2557 35.2411 20.7915 35.2411H22.9553C23.2941 35.2411 23.5687 35.5157 23.5687 35.8544V46.6712C23.5687 47.01 23.2941 47.2845 22.9553 47.2845H13.9716C12.8864 47.2845 11.8394 47.1121 10.8524 46.7982C4.63291 45.3368 0 39.7526 0 33.0878C0 25.3111 6.30539 19.0032 14.0846 19.0032L14.0848 19.0012Z"
                  fill="#307FE1" />
              </svg>
            </div>
            
            <span class="font-semibold text-sm text-[color:var(--Primary-Deep-Blue,#0A0A5F)] sm:text-base">Upload Certificate</span>
          </div>
          <p class="text-xs sm:text-sm text-gray-500 mt-2" *ngIf="ImageAray.length === 0">Drag files here in JPG/JPEG/PNG/WEBP/PDF | File Size : Max 5MB</p>


          <!-- File Upload Grid - Show when images are selected -->
          <div *ngIf="ImageAray.length > 0" class="space-y-4">
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-4 max-md:w-[220px]">
              <!-- Add More Upload Box -->
              <div class="relative w-full aspect-square border-dashed border-2 border-[color:var(--Primary-Deep-Blue,#0A0A5F)] rounded-lg cursor-pointer flex flex-col items-center justify-center hover:bg-blue-50 transition-colors"
                   (click)="fileInput.click()">
                <input type="file" accept=".jpg,.jpeg,.png,.webp,.pdf" #fileInput class="hidden" (change)="onFileSelected($event)" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 56 40" fill="none" class="sm:w-8 sm:h-6">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0848 11.0012C15.3425 11.0012 16.5596 11.1665 17.7191 11.4756C19.4297 5.2683 25.1149 0.708984 31.8631 0.708984C38.6261 0.708984 44.3188 5.28479 46.017 11.5111C49.3135 11.8944 51.8746 14.695 51.8746 18.0944C51.8746 18.9257 51.7212 19.7186 51.4433 20.4518C54.1865 22.306 56 25.4445 56 28.9878C56 34.6513 51.3667 39.2845 45.7032 39.2845H33.0464C32.7077 39.2845 32.4331 39.01 32.4331 38.6712V27.8544C32.4331 27.5157 32.7077 27.2411 33.0464 27.2411H35.2103C35.7461 27.2411 36.0243 26.6023 35.6594 26.21L28.4499 18.4598C28.2074 18.1991 27.7944 18.1991 27.5518 18.4598L20.3424 26.21C19.9775 26.6023 20.2557 27.2411 20.7915 27.2411H22.9553C23.2941 27.2411 23.5687 27.5157 23.5687 27.8544V38.6712C23.5687 39.01 23.2941 39.2845 22.9553 39.2845H13.9716C12.8864 39.2845 11.8394 39.1121 10.8524 38.7982C4.63291 37.3368 0 31.7526 0 25.0878C0 17.3111 6.30539 11.0032 14.0846 11.0032L14.0848 11.0012Z" fill="#307FE1"/>
                </svg>
                <span class="font-semibold text-xs sm:text-sm mt-1 text-[color:var(--Primary-Deep-Blue,#0A0A5F)]">Add More</span>
              </div>

              <!-- Uploaded Files -->
              <div *ngFor="let file of ImageAray" class="relative w-full aspect-square border rounded-lg overflow-hidden group">
                <!-- Display image if it's an image file -->
                <img *ngIf="!isPDF(file)" [src]="getFileSource(file)" alt="Uploaded" class="w-full h-full object-cover" />
                
                <!-- Display PDF icon if it's a PDF file -->
                <div *ngIf="isPDF(file)" class="w-full h-full flex flex-col items-center justify-center bg-gray-50 text-gray-600">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-red-600">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                  <span class="text-xs mt-1 text-center px-1">{{ getFileName(file) }}</span>
                </div>
                
                <button (click)="removeImage(file)"
                  class="absolute top-1 right-1 bg-white rounded-full w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-xs sm:text-sm text-red-600 font-bold opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-50">
                  ✕
                </button>
              </div>
            </div>
            
            <p class="text-xs sm:text-sm text-gray-500">Drag files here in JPG/JPEG/PNG/WEBP/PDF | File Size : Max 5MB</p>
            
            <!-- File Validation Errors -->
            <div *ngIf="fileValidationErrors && fileValidationErrors.length > 0" class="mt-2">
              <div *ngFor="let error of (fileValidationErrors || [])" class="text-red-500 text-xs sm:text-sm mb-1">
                {{ error }}
              </div>
            </div>
          </div>
        </div>

        <!-- Note -->
        <div class="text-xs sm:text-sm leading-4 sm:leading-5 font-bold font-['Uni Neue'] text-[color:var(--Text-Black,#000)] rounded-[8px] bg-[color:var(--Neutrals-Off-White,#F2F2F2)] p-2 sm:p-2">
          Note: Certificate will be submitted for verification. Processing may take 2–3 days.
        </div>
      </form>
    </div>

    <!-- Mobile Category Bottom Sheet -->
    <div *ngIf="showCategoryBottomSheet && isMobile" 
         class="fixed inset-0 z-[60] flex items-end justify-center md:hidden">
      <!-- Backdrop -->
      <div class="absolute inset-0 bg-black bg-opacity-40" (click)="closeCategoryBottomSheet()"></div>
      
      <!-- Bottom Sheet Content -->
      <div class="relative w-full bg-white rounded-t-2xl shadow-lg max-h-[85vh] overflow-hidden animate-slide-up">
        <!-- Header -->
        <div class="flex justify-between items-center p-4 border-b border-gray-200 bg-white sticky top-0">
          <h2 class="text-lg font-bold text-[#0A0A5F]">Scrap Category</h2>
          <button (click)="closeCategoryBottomSheet()" class="text-gray-500 hover:text-gray-700 text-xl p-1">
            ✕
          </button>
        </div>
        
        <!-- Category Options -->
        <div class="bg-white overflow-y-auto max-h-[calc(85vh-140px)]">
          <div *ngFor="let category of scrapCategoryOptions; let last = last" 
               class="px-4 py-3" 
               [class.border-b]="!last" 
               [class.border-gray-200]="!last">
            <label class="flex items-center cursor-pointer">
              <input type="radio" 
                     name="scrapCategoryRadio"
                     [value]="category?.name" 
                     [checked]="selectedCategoryValue === category?.name"
                     (change)="selectCategory(category?.name)"
                     class="w-5 h-5 text-[#0A0A5F] focus:ring-[#0A0A5F] focus:ring-2 cursor-pointer accent-[#0A0A5F]">
              <span class="ml-3 text-sm sm:text-base text-gray-900">{{ category?.name }}</span>
            </label>
          </div>
        </div>
        
        <!-- Footer with Proceed button -->
        <div class="p-4 bg-white sticky bottom-0 border-t border-gray-200">
          <button (click)="confirmCategorySelection()" 
                  [disabled]="!selectedCategoryValue"
                  class="w-full py-3 px-4 bg-[#0A0A5F] text-white font-medium rounded-lg hover:opacity-90 disabled:bg-gray-400 disabled:cursor-not-allowed transition-opacity">
            Proceed
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Date Picker Modal -->
    <div *ngIf="showDatePicker && isMobile" 
         class="fixed inset-0 z-[60] flex items-end justify-center md:hidden">
      <!-- Backdrop -->
      <div class="absolute inset-0 bg-black bg-opacity-40" (click)="closeDatePicker()"></div>
      
      <!-- Modal Content - Dark themed calendar matching the image -->
      <div class="relative w-full bg-[#fbfbfb] rounded-t-2xl shadow-lg max-h-[85vh] overflow-hidden animate-slide-up">
        <!-- Calendar Header -->
        <div class="flex justify-between items-center p-4 border-b border-gray-600 bg-[#fbfbfb] sticky top-0">
          <div class="flex items-center gap-2">
            <button (click)="previousMonth()" class="p-1 hover:bg-gray-700 rounded">
              <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>
            <div class="flex items-center gap-1">
              <span class="text-lg font-semibold text-black">{{ getCurrentMonthYear() }}</span>
              <button (click)="toggleMonthYearPicker()" class="p-1 hover:bg-gray-700 rounded">
                <svg class="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
            </div>
            <button (click)="nextMonth()" class="p-1 hover:bg-gray-700 rounded">
              <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>
          </div>
        </div>
        
        <!-- Month/Year Picker (when toggled) -->
        <div *ngIf="showMonthYearPicker" class="p-4 border-b border-gray-600 bg-[#fbfbfb]">
          <div class="grid grid-cols-3 gap-2">
            <select [(ngModel)]="selectedYear" (change)="onYearChange()" class="p-2 border border-gray-500 rounded bg-[#fbfbfb] text-black">
              <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
            </select>
            <select [(ngModel)]="selectedMonth" (change)="onMonthChange()" class="p-2 border border-gray-500 rounded col-span-2 bg-[#fbfbfb] text-black">
              <option *ngFor="let month of monthNames; let i = index" [value]="i">{{ month }}</option>
            </select>
          </div>
        </div>
        
        <!-- Calendar Grid - White background like in image -->
        <div class="p-4 bg-white">
          <!-- Days of Week Header -->
          <div class="grid grid-cols-7 gap-1 mb-2">
            <div *ngFor="let day of dayNames" class="text-center text-sm font-medium text-gray-500 py-2">
              {{ day }}
            </div>
          </div>
          
          <!-- Calendar Days -->
          <div class="grid grid-cols-7 gap-1">
            <div *ngFor="let day of calendarDays" 
                 class="text-center py-2 rounded cursor-pointer transition-colors"
                 [ngClass]="{
                   'text-gray-400': day.isOtherMonth,
                   'text-gray-900 hover:bg-gray-100': !day.isOtherMonth && !day.isSelected && !day.isToday,
                   'bg-[#307FE1] text-white font-semibold rounded-full': day.isSelected,
                   'bg-blue-100 text-blue-700 font-semibold': day.isToday && !day.isSelected,
                   'opacity-50 cursor-not-allowed': day.isDisabled
                 }"
                 (click)="selectDate(day)"
                 [class.pointer-events-none]="day.isDisabled">
              {{ day.date }}
            </div>
          </div>
        </div>
        
        <!-- Footer with Back and Proceed buttons (Mobile Only) -->
        <div class="p-4 bg-[#fbfbfb] sticky bottom-0">
          <div class="flex gap-3">
            <button (click)="closeDatePicker()" 
                    class="flex-1 py-3 px-4 border border-gray-500 text-black font-medium rounded-lg hover:bg-gray-700 bg-transparent">
              Back
            </button>
            <button (click)="confirmDateSelection()" 
                    [disabled]="!selectedDateValue"
                    class="flex-1 py-3 px-4 bg-[#307FE1] text-white font-medium rounded-lg hover:bg-blue-900 disabled:bg-gray-600 disabled:cursor-not-allowed">
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer - Fixed -->
    <div class="flex-shrink-0 border-t border-gray-200 p-4 sm:p-2">
      <div class="flex flex-row gap-3 w-full">
        <button type="button" (click)="closeModal()" class="flex-1 px-4 py-2 border border-[color:var(--Primary-Deep-Blue,#0A0A5F)] text-[color:var(--Primary-Deep-Blue,#0A0A5F)] rounded-lg text-sm sm:text-base font-medium hover:bg-gray-50 transition-colors"(click)="closeModal()">Cancel</button>
        <button type="submit" (click)="onSubmit()" class="flex-1 px-4 py-2 bg-[color:var(--Primary-Deep-Blue,#0A0A5F)] text-white rounded-lg text-sm sm:text-base font-medium hover:opacity-90 transition-opacity">Save</button>
      </div>
    </div>
  </div>
</div>



</div>